/** Query strings sometimes wrap or encode stray quotes around the JWT (e.g. Doppio or pasted URLs). */
export function normalizePrintTokenFromSearch(raw: string): string {
    let t = raw.trim();
    try {
        t = decodeURIComponent(t);
    } catch {
        /* keep trimmed raw */
    }
    t = t.trim();
    // Strip paired quotes and stray trailing/leading quotes (%22 breaks signature base64url decode)
    let prev = "";
    while (prev !== t) {
        prev = t;
        t = t.replace(/^["']+|["']+$/g, "").trim();
    }
    return t;
}
